import { ScenarioEditSection } from '@apps/attentionADJUST/components/organisms/scenarioEditSection/ScenarioEditSection';
import { FC } from 'react';

export const ScenarioEditPage: FC = () => {
    return <ScenarioEditSection />;
};
